<template>
	<div class="bg-slate-50 flex flex-grow flex-col">
		<div
			class="fixed bottom-0 left-0 right-0 top-0 opacity-[0.06]"
			:style="{
				backgroundImage: `url('/img/bg_pattern.png')`,
				backgroundRepeat: 'repeat',
				backgroundSize: '512px 512px'
			}"
		></div>
		<div class="z-[1] flex flex-grow flex-col px-6 pb-12 pt-12">
			<NuxtLink :to="$routeUrl.HomeUrl()" class="self-center">
				<img src="/img/app_logo.png" alt="" :class="['h-12 w-auto duration-300 lg:h-16']" />
			</NuxtLink>
			<div class="flex-grow"></div>
			<div
				class="bg-white my-12 flex w-full max-w-2xl flex-col self-center rounded-2xl px-6 py-12"
				:style="{
					boxShadow: `0px 4px 20px rgba(0, 0, 0, 0.1), 0px 4px 30px rgba(0, 0, 0, 0.2)`
				}"
			>
				<div class="flex w-full max-w-lg flex-col space-y-6 self-center">
					<NuxtLink
						v-if="!userStore.user?.id || userStore.user?.type != 'company-user'"
						:class="['ripple-bg-slate-200 flex cursor-pointer items-center rounded-full px-3 py-3']"
						:to="
							userStore.user?.id && userStore.user?.type != 'company-user'
								? $routeUrl.PanelDashboardUrl()
								: $routeUrl.LoginUrl()
						"
					>
						<span class="me-3 flex">
							<Icon
								name="mdi:administrator"
								class="text-white h-8 w-8 text-wrap rounded-full bg-primary p-[20%]"
							/>
						</span>
						<span class="text-slate-600 text-sm font-bold">
							{{ $t("system_admin_login") }}
						</span>
					</NuxtLink>
					<template v-for="company in companies" :key="company.id">
						<NuxtLink
							v-if="
								!userStore.user?.id ||
								(userStore.user?.type == 'company-user' && userStore.user?.company_id == company.id)
							"
							:class="['ripple-bg-slate-200 flex cursor-pointer items-center rounded-full px-3 py-3']"
							:external="
								company.is_payroll_domain_ok &&
								company.is_change_payroll_domain &&
								!!company.payroll_baseurl
							"
							:to="
								company.is_payroll_domain_ok &&
								company.is_change_payroll_domain &&
								company.payroll_baseurl
									? company.payroll_baseurl
									: userStore.user?.id && userStore.user?.type == 'company-user'
										? $routeUrl.CompanyDashboardUrl()
										: $routeUrl.CompanyLoginUrl(company.id)
							"
						>
							<span class="me-3 flex h-8 w-8 rounded-full bg-primary">
								<img
									v-if="company.maskable_image_id"
									:src="$config.public.baseUrl + company.maskable_image_thumb1"
									alt=""
									class="h-full w-full rounded-full"
								/>
								<Icon
									v-else
									name="mdi:company"
									class="text-white h-full w-full text-wrap rounded-full bg-primary p-[20%]"
									:style="{
										background: company.color ? company.color + ' !important' : undefined
									}"
								/>
							</span>
							<span class="text-slate-600 text-sm font-bold">
								{{ $t("n_personnel_login", { n: company.title }) }}
							</span>
						</NuxtLink>
					</template>
				</div>
			</div>
			<div class="flex-grow"></div>
			<p class="mt-5 w-full max-w-2xl self-center text-center text-xs text-[#382C5C]">
				{{ $t("app_description") }}
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { Company } from "~/models/company"

const userStore = useUserStore()

defineProps<{
	companies: Company[]
}>()
</script>
